"use server";

import { getServerSession } from "next-auth";
import { authOptions } from "@/lib/auth";
import { prisma } from "@/lib/prisma";

export async function logCrave() {
    const session = await getServerSession(authOptions);
    if (!session?.user?.email) return;

    const user = await prisma.user.findUnique({
        where: { email: session.user.email },
    });

    if (!user) return;

    await prisma.craveLog.create({
        data: {
            userId: user.id,
        },
    });
}
